import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { paginationEllipsisStyles } from './styles/pagination-ellipsis.styles';
import type { PaginationEllipsisPropsInterface } from './types/pagination-ellipsis.types';

/**
 * Renders a non-interactive ellipsis placeholder in a pagination range.
 * Pairs with `Pagination.Item` to occupy a slot between the persistent
 * first/last page buttons and the current page range.
 *
 * @since 10.17.0
 */
export const PaginationEllipsis = forwardRef<HTMLSpanElement, PaginationEllipsisPropsInterface>(
  (props: PaginationEllipsisPropsInterface, forwardedRef) => {
    const { children = '\u2026', className, css: cssProp, ...rest } = props;

    const styles = css(paginationEllipsisStyles.raw(), cssProp);

    return (
      <span
        className={cx('c11n', 'c11n_pagination__ellipsis', styles, className)}
        data-c11n-component="Pagination.Ellipsis"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      >
        {children}
      </span>
    );
  },
);

PaginationEllipsis.displayName = 'Pagination.Ellipsis';
